import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['display', 'input'];

  initialize() {
    this.addHttpsToString = this.addHttpsToString.bind(this);
  }

  connect() {
    this.displayTarget.addEventListener('keyup', this.addHttpsToString);
    this.displayTarget.addEventListener('paste', this.addHttpsToString);
  }

  disconnect() {
    this.displayTarget.removeEventListener('keyup', this.addHttpsToString);
    this.displayTarget.removeEventListener('paste', this.addHttpsToString);
  }

  addHttpsToString() {
    const { value } = this.displayTarget;

    if (value.match(/^https:\/\//)) {
      this.inputTarget.value = value;
      this.displayTarget.value = value.replace(/^https:\/\//, '');
      return;
    }

    return this.inputTarget.value = `https://${value}`;
  }
}
